import { GameVars } from "../../GameVars";
import { BoardContainer } from "./BoardContainer";
import { BoardScene } from "./BoardScene";
import { Tile } from "./Tile";
import { GameManager } from "../../GameManager";
import { AchievementsManager } from "../../AchievementsManager";
import * as Mahjong from "@ravalmatic/mahjong-engine";

// https://www.mahjong.com/game/Mah+Jong

export class BoardManager {

    public static init(): void {
        
        Tile.id = 0;

        GameVars.levelCleared = false;
        GameVars.bestScore = null;
        GameVars.bestTime = null;
        GameVars.levelUnlocked = false;

        GameVars.mahjongEngine = new Mahjong.Engine(GameVars.boardsData);

        if (GameVars.restoredSession) {

            const action = GameVars.gameData.data.savedActions[0];
            GameVars.levelIndex = action.data.levelIndex;
            const seed = action.data.seed;

            GameVars.mahjongEngine.init(GameVars.levelIndex, null, seed);
            GameVars.mahjongEngine.processActions(GameVars.gameData.data.savedActions); 

        } else {

            const levelID = GameVars.boardsData[GameVars.levelIndex].id;

            for (const cat in GameVars.gameData.categoriesData) {
                if (GameVars.gameData.categoriesData.hasOwnProperty(cat)) {
    
                    const levelsData = GameVars.gameData.categoriesData[cat].levelsData;
                    const level = levelsData.find(level => level.id === levelID);
    
                    if (level) {
                        GameVars.bestScore = level.highScore;
                        GameVars.bestTime = level.time;
                        break;
                    }
                }
            }

            const seed = Math.floor(Math.random() * 1e4);
            const boardData = null;
            // const boardData = {"map":[[0,[[0,[[8,7],24]],[1,[6,22]],[2,[4,[8,7],24]],[3,[2,6,22]],[4,[0,4,[8,7],24]],[5,[2,6,22]],[6,[4,[8,7],24]],[7,[6,22]],[8,[[8,7],24]]]],[1,[[1,[[8,7],24]],[2,[6,22]],[3,[4,[8,7],24]],[4,[2,6,22]],[5,[4,[8,7],24]],[6,[6,22]],[7,[[8,7],24]]]],[2,[[2,[[8,2]]],[3,[6,20,23]],[4,[4,9,[12,2],17]],[5,[6,20,23]],[6,[[8,2]]]]],[3,[[2,[[7,2]]],[3,[[20,3]]],[4,[5,9,[12,2],17]],[5,[[20,3]]],[6,[[7,2]]]]],[4,[[2,8],[3,[[12,7]]],[4,[[6,3]]],[5,[[12,7]]],[6,8]]]],"id":"3348595910","name":"Flat Iron","cat":"Forms","cols":26,"rows":10,"levels":5,"n":138,"hints":2,"tiles":[[[null,null,null,null,null],null,[null,null,null,"flowers_1",null,"flowers_1"],null,[null,null,"symbols_1",null,"circles_1",null,"circles_4"],null,[null,"dragons_8",null,"dragons_8",null,"bamboo_4",null,"symbols_5"],null,["bamboo_5",null,"bamboo_9",null,"bamboo_8",null,"bamboo_2",null,"bamboo_8"],null,["bamboo_3",null,"circles_3",null,"seasons_7",null,"circles_2",null,"symbols_8"],null,["winds_1",null,"bamboo_9",null,"symbols_3",null,"flowers_2",null,"symbols_6"],null,["circles_3",null,"bamboo_3",null,"bamboo_4",null,"bamboo_5",null,"circles_2"],null,["flowers_4",null,"symbols_1",null,"circles_6",null,"dragons_6",null,"bamboo_1"],null,["bamboo_4",null,"bamboo_5",null,"seasons_7",null,"flowers_4",null,"circles_8"],null,["bamboo_7",null,"circles_9",null,"seasons_8",null,"circles_6",null,"winds_3"],null,[null,"circles_8",null,"seasons_6",null,"symbols_2",null,"circles_9"],null,["circles_3",null,"winds_2",null,"dragons_6",null,"seasons_8",null,"circles_4"]],[null,null,[null,null,null,null,"bamboo_7"],null,[null,null,null,"symbols_8",null,"symbols_9"],null,[null,null,"bamboo_6",null,"bamboo_6",null,"dragons_6"],null,[null,"symbols_5",null,"flowers_2",null,"circles_1",null,"bamboo_1"],null,[null,"circles_4",null,"bamboo_9",null,"circles_7",null,"dragons_8"],null,[null,"circles_5",null,"circles_7",null,"seasons_6",null,"symbols_1"],null,[null,"circles_1",null,"circles_2",null,"bamboo_6",null,"flowers_3"],null,[null,"dragons_8",null,"winds_2",null,"symbols_6",null,"circles_8"],null,[null,"symbols_7",null,"bamboo_2",null,"circles_3",null,"seasons_6"],null,[null,"circles_9",null,"flowers_1",null,"seasons_9",null,"flowers_3"],null,[null,null,"seasons_7",null,"symbols_9",null,"flowers_3"],null,[null,"winds_1",null,"seasons_8",null,"seasons_8",null,null]],[null,null,null,null,[null,null,null,null,"bamboo_3"],null,[null,null,null,"circles_1",null,"dragons_7"],null,[null,null,"bamboo_3",null,null,null,"symbols_4"],[null,null,null,null,"flowers_4"],[null,null,"circles_7",null,null,null,"seasons_9"],null,[null,null,null,null,"bamboo_1"],null,[null,null,null,null,"bamboo_8"],null,null,[null,null,null,null,"circles_6"],null,null,[null,null,null,"dragons_7",null,"flowers_2"],null,null,[null,null,null,"bamboo_8",null,"circles_7"]],[null,null,null,null,null,[null,null,null,null,"bamboo_4"],null,[null,null,"seasons_9",null,null,null,"bamboo_5"],null,[null,null,"bamboo_9",null,"circles_4",null,"circles_8"],null,null,[null,null,null,null,"seasons_7"],null,[null,null,null,null,"winds_3"],null,null,[null,null,null,null,"symbols_7"],null,null,[null,null,null,"dragons_7",null,"symbols_1"],null,[null,null,null,"symbols_2",null,"bamboo_7"],null,[null,null,null,"bamboo_2",null,null]],[null,null,null,null,null,null,[null,null,null,null,null],null,[null,null,"winds_4",null,"circles_6",null,null],null,[null,null,null,null,"circles_2"],null,[null,null,null,"circles_5",null,"bamboo_2"],null,[null,null,null,"symbols_3",null,"flowers_1"],null,[null,null,null,"circles_9",null,"bamboo_7"],null,[null,null,null,"bamboo_6",null,"dragons_7"],null,[null,null,null,"flowers_4",null,"dragons_6"],null,[null,null,null,"bamboo_1",null,"symbols_4"],null,[null,null,null,"winds_4",null,null]]],"seconds":19};

            GameVars.mahjongEngine.init(GameVars.levelIndex, boardData, seed);

            const action: Mahjong.Action = {
                type: Mahjong.ActionType.INIT,
                data: {
                    levelIndex: GameVars.levelIndex,
                    seed: seed
                }
            };
    
            GameVars.gameData.data.savedActions.push(action);
            GameManager.writeGameData();
        }

        BoardManager.addListeners();

        BoardManager.startGame();

        AchievementsManager.onGameStarted();

        GameVars.paused = false;
        GameVars.restoredSession = false;
        GameVars.markingUnselectableTiles = false;
    }

    public static update(): void {
            
        if (GameVars.paused) {
            return;
        }

        GameVars.mahjongEngine.update();
    }

    public static pauseResumeGame(): void {

        GameVars.paused = !GameVars.paused;

        if (GameVars.paused) {
            (window as any).CrazyGames.SDK.game.gameplayStop();
        } else {
            (window as any).CrazyGames.SDK.game.gameplayStart();
        }

        BoardScene.currentInstance.onGamePausedResumed();
    }

    public static startGame(): void {
        
        BoardScene.currentInstance.startGame();

        (window as any).CrazyGames.SDK.game.gameplayStart();
    }

    public static resetGame(): void {
        
        GameVars.levelReset = true;

        GameVars.gameData.firstSession = false;
        GameVars.gameData.data.savedActions = [];
        GameManager.writeGameData();

        GameManager.enterBoardScene(null, false);
    }

    public static shuffle(): void {
            
        GameVars.mahjongEngine.shuffleBoard();
    }

    public static showInfo(): void {

        GameVars.paused = true;

        BoardScene.currentInstance.showInfo();

        (window as any).CrazyGames.SDK.game.gameplayStop();
    }

    public static hideInfo(): void {

        GameVars.paused = false;

        BoardScene.currentInstance.hideInfo();

        (window as any).CrazyGames.SDK.game.gameplayStart();
    }

    public static onTileSelected(tileData: Mahjong.TileData): void {

        GameVars.matchSet = [];

        BoardContainer.currentInstance.unMarkHints();
        
        GameVars.mahjongEngine.onTileSelected(tileData);
    }

    public static onTileMarkedAsHintSelected(tileData: Mahjong.TileData): void {

        if (GameVars.matchSet.length === 2) {
            GameVars.mahjongEngine.onTileSelected(GameVars.matchSet[0]);
            GameVars.mahjongEngine.onTileSelected(GameVars.matchSet[1]);
        } else {
            GameVars.mahjongEngine.onTileSelected(tileData);
        }
    }

    public static onBoardCleared(): void {

        GameVars.levelCleared = true;
        GameVars.paused = true;

        const cat = GameVars.boardsData[GameVars.levelIndex].cat;
        const id = GameVars.boardsData[GameVars.levelIndex].id;

        // VER SI HAS SIDO JUGADO ANTES
        const levelsData = GameVars.gameData.categoriesData[cat].levelsData;

        // mirar si hay uno con el mismo id
        let levelData = null;

        for (let i = 0; i < levelsData.length; i++) {
            if (levelsData[i].id === id) {
                levelData = levelsData[i];
                break;
            }
        }

        GameVars.bestScore = null;
        GameVars.bestTime = null;

        if (levelData) {

            if (levelData.time === 0) {
                GameVars.levelUnlocked = true;
            }

            // VER SI SE HA MEJORADO EL TIEMPO
            if (GameVars.mahjongEngine.boardData.seconds < levelData.time || levelData.time === 0) {
               
                if (levelData.time > 0) {
                    GameVars.bestTime = GameVars.mahjongEngine.boardData.seconds;
                }

                levelData.time = GameVars.mahjongEngine.boardData.seconds;
            }

            // VER SI SE HA MEJORADO LA PUNTUACION
            if (GameVars.mahjongEngine.scoreManager.score > levelData.highScore) {
                levelData.highScore = GameVars.mahjongEngine.scoreManager.score;
                GameVars.bestScore = levelData.highScore;
            }

        } else {

            GameVars.levelUnlocked = true;
            // insertarlo
            GameVars.gameData.categoriesData[cat].levelsData.push({id: id, highScore: GameVars.mahjongEngine.scoreManager.score, time: GameVars.mahjongEngine.boardData.seconds});
            GameVars.justUnlockedBoardsData.push(cat);
        }

        AchievementsManager.onLevelCompleted(levelData === null);

        BoardScene.currentInstance.onBoardCleared();

        GameVars.gameData.firstSession = false;
        GameVars.gameData.data.savedActions = [];
        GameManager.writeGameData();

        (window as any).CrazyGames.SDK.game.happytime();
    }

    public static undo(): void {

        let action: Mahjong.Action;
        let i: number;

        for (i = GameVars.gameData.data.savedActions.length - 1; i >= 0; i--) {
            
            action = GameVars.gameData.data.savedActions[i];

            if (action.type === Mahjong.ActionType.TILES_SELECTED) {
                break;
            }
        }

        if (i === -1) {
            // no se encontró ningún TILES_SELECTED q revertir
            return;
        }

        GameVars.gameData.data.savedActions.splice(i, 1);

        const tileA = action.data.tA;
        const tileB = action.data.tB;

        GameManager.writeGameData();

        GameVars.paused = false;
        GameVars.restoredSession = false;

        const t = GameVars.mahjongEngine.boardData.seconds;
       
        GameVars.mahjongEngine = new Mahjong.Engine(GameVars.boardsData);

        action = GameVars.gameData.data.savedActions[0];
        GameVars.levelIndex = action.data.levelIndex;
        const seed = action.data.seed;

        GameVars.mahjongEngine.init(GameVars.levelIndex, null, seed);
        GameVars.mahjongEngine.processActions(GameVars.gameData.data.savedActions); 

        BoardManager.addListeners();

        // TODO: MEJORAR ESTO EN PROXIMAS VERSIONES
        GameVars.mahjongEngine.boardData.seconds = t;

        BoardScene.currentInstance.undo(tileA, tileB);  
    }

    public static hintsReset(): void {

        GameVars.mahjongEngine.hintsReset();

        const action: Mahjong.Action = { 
            type: Mahjong.ActionType.HINTS_RESET,
            data: null
        };

        GameVars.gameData.data.savedActions.push(action);
    }

    private static onMatch(tileA: Mahjong.TileData, tileB: Mahjong.TileData, scoreData: {score: number, deltaSore: number, combo: number}): void {    

        BoardScene.currentInstance.onMatch(tileA, tileB, scoreData);

        // desmarcar las fichas de GameVars.matchSet que no sean tileA ni tileB
        if (GameVars.matchSet.length > 2) {
            GameVars.matchSet.forEach((tileData: Mahjong.TileData) => {
                if (tileData !== tileA && tileData !== tileB) {
                    BoardContainer.currentInstance.unMarkHints(tileData);
                }
            });
        }

        AchievementsManager.onMatch(tileA, tileB);

        if (!GameVars.levelCleared) {
            const action: Mahjong.Action = { 
                type: Mahjong.ActionType.TILES_SELECTED,
                data: {
                    tA: tileA,
                    tB: tileB,
                    s: GameVars.mahjongEngine.boardData.seconds,
                }
            };
    
            GameVars.gameData.data.savedActions.push(action);
            GameManager.writeGameData();
        }
    }

    private static onNoMatch(tileA: Mahjong.TileData, tileB: Mahjong.TileData): void {

        BoardContainer.currentInstance.unMarkAsSelected(tileA);
        BoardContainer.currentInstance.markAsSelected(tileB);
    }

    private static onHint(set: Mahjong.TileData[]): void {
        
        GameVars.matchSet = set;

        BoardScene.currentInstance.onHint();

        const action: Mahjong.Action = { 
            type: Mahjong.ActionType.HINT,
            data: {}
        };

        GameVars.gameData.data.savedActions.push(action);

        GameManager.writeGameData();
    }

    private static onTileToMarkAsSelected(tile: Mahjong.TileData): void {

        BoardContainer.currentInstance.markAsSelected(tile);
    }

    private static onTileToUnmarkAsSelected(tile: Mahjong.TileData): void {

        BoardContainer.currentInstance.unMarkAsSelected(tile);
    }

    private static onLockedTile(tile: Mahjong.TileData): void {

        if (GameVars.markingUnselectableTiles) {
            GameVars.markingUnselectableTiles = false;
            BoardContainer.currentInstance.unMarkUnselectableTiles();
        } else {
            GameVars.markingUnselectableTiles = true;
            BoardContainer.currentInstance.onLockedTile(tile);
        }
    }

    private static onShuffle(): void {

        BoardScene.currentInstance.onShuffle();
    }

    private static addListeners(): void {

        const engine = GameVars.mahjongEngine;

        engine.addEventListener(Mahjong.Event.MATCH, BoardManager.onMatch, BoardManager);
        engine.addEventListener(Mahjong.Event.NO_MATCH, BoardManager.onNoMatch, BoardManager);
        engine.addEventListener(Mahjong.Event.HINT, BoardManager.onHint, BoardManager);
        engine.addEventListener(Mahjong.Event.MARK_AS_SELECTED, BoardManager.onTileToMarkAsSelected, BoardManager);
        engine.addEventListener(Mahjong.Event.UNMARK_AS_SELECTED, BoardManager.onTileToUnmarkAsSelected, BoardManager);
        engine.addEventListener(Mahjong.Event.LOCKED_TILE, BoardManager.onLockedTile, BoardManager);
        engine.addEventListener(Mahjong.Event.ON_SHUFFLE, BoardManager.onShuffle, BoardContainer);
        engine.addEventListener(Mahjong.Event.ON_BOARD_CLEARED, BoardManager.onBoardCleared, BoardManager);
    }
}
